/**
 * Functionality for Contact form modals
 */
export default () => {

  /**
   * Handles loading the Contact form via AJAX
   */
  class ContactFormModalLoader {

    constructor() {
      this.formEndpoint = '/wp/wp-admin/admin-ajax.php';
      this.formMarkup = '';

      // Binding to body lets us intercept events before listeners attached to
      // HTML, which is good. We want to be the only behavior for applicable
      // links.
      $('body').on('click', 'a[href$="#contact-form"]', (event) => {
        this.openContactModal(event);
      });
    }

    openContactModal(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (!this.$modalForm) {
        this.loadContactModal(event);
        return;
      }

      $.magnificPopup.open({
        closeMarkup: '<button title="%title%" type="button" class="mfp-close"><span class="sr-text">Close Pop-up</span></button>',
        closeOnBgClick: false,
        mainClass: 'contact-form-modal',
        items: {
          src: '#contact-form-modal-wrapper',
          type: 'inline'
        }
      });
    }

    loadContactModal() {
      if (this.request) {
        // We're already loading/have loaded the modal
        return;
      }

      window.aauwLoading.addEvent('contact-us-modal-loading');

      // Pre-populate parameters based on URL query strings, if any
      const fieldParams = {};
      const modalUrl = new URL(event.target.href);
      for (const queryParam of modalUrl.searchParams.entries()) {
        fieldParams[queryParam[0]] = queryParam[1];
      }

      const ajaxData = {
        action: 'get_aauw_contact_form',
        fieldParams
      };

      this.request = $.post(
        // url
        this.formEndpoint,
        // data
        ajaxData,
        // success
        (response) => {
          window.aauwLoading.endEvent('contact-us-modal-loading');

          if (!response) {
            // We failed to get form info for some reason.
            // Wipe request object so that an attempt can be made again the next
            // time the user clicks.
            this.request = null;
            throw 'Did not receive form markup from endpoint!';
          } else {
            this.$modalForm = $('<div class="contact-form-modal-wrapper mfp-hide" id="contact-form-modal-wrapper">' + response.form_markup + '</div>');

            // We need to fix the action URL, which should point at the current
            // page, but will be pointed at the AJAX processing URL instead
            this.$modalForm.find('form[action]').each(function() {
              const $this = $(this),
                    actionPieces = $this.attr('action').split('#')
              ;
              actionPieces.shift();
              actionPieces.unshift(window.location.pathname);
              const newAction = actionPieces.join('#');
              $this.attr(
                'action',
                newAction
              );
            });

            $('body').append(this.$modalForm);

            // if (window.gformInitDatepicker) {
            //   gformInitDatepicker();
            // }

            this.$modalForm.trigger('aauw-dynamic-form-inserted');

            this.openContactModal();
          }
        },
        // dataType
        'json'
      );
    }

  }

  $(function() {
    new ContactFormModalLoader();
  });

};
